module.exports = __webpack_public_path__ + "img/Hero_Alt.ef3efc8c.jpg";